import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import JwtDecode from 'jwt-decode';
import logo_hr from '../../../assets/images/brand/assista_horizontal-punchout.svg';
import * as R from 'ramda';

import { Avatar } from './../../../_common/avatar';

export const Navbar = ({user, profilePicture, profilePictureDocument, logoContent}) => {
    const [widthIsBigger, setWidthIsBigger] = useState(false);
    const isFirefox = typeof InstallTrigger !== 'undefined';

    useEffect(()=>{
        if (!R.isNil(profilePictureDocument)){
            let i = new Image();
            i.onload = function () {
                setWidthIsBigger(i.width > i.height);
            };
            i.src = profilePicture;
        }
    }, [profilePictureDocument, profilePicture]);

    let roles = [];
    var accessToken = localStorage.getItem("access_token");
    if (!R.isNil(accessToken) && accessToken !== '') {
        var decodedJwt = JwtDecode(accessToken);        
        let rolesFromToken = decodedJwt["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        if(!R.isNil(rolesFromToken)){
            if(Array.isArray(rolesFromToken)){
                roles = rolesFromToken;
            }else{
                roles = [rolesFromToken];
            }
        }
    }

    const logo = R.isNil(logoContent) ? logo_hr : logoContent;

    return (
        <React.Fragment >
            <header className={"aside navbar navbar-expand-lg text-white py-4 py-gd-sm navbar-dark" + (isFirefox ? ' pb-lg-0' : ' pt-lg-5')}>
                <div className="container-fluid px-gutter justify-content-between align-item-center d-lg-flex flex-lg-column h-100">
                    <Link className={"navbar-brand mx-lg-auto mb-gd-sm" + (isFirefox ? ' mb-lg-4' : '')} to={"/anticipa" + (!R.isNil(user.setupCompletedDate) ? '/dashboard' : '')}>
                        <img className={"img-fluid" + (logoContent ? " rounded-sm img-avatar" : "")} src={logo} alt={"Assist@" + (logoContent ? " Partner" : "")} width="212" onError={(ev) => ev.target.src = logo_hr} />
                        {/* <img className="img-fluid d-none d-lg-block" src={logo} alt="Assist@" width="146" /> */}
                        <h1 className="sr-only visually-hidden">Assist@: Menu</h1>
                    </Link>
                    <div className="d-flex align-items-center">
                        <button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                    </div>
                    <div className={"collapse navbar-collapse flex-column mt-3 mt-lg-0"} id="navbar-collapse">
                        <nav className="card w-100 rounded-cta bg-stage flex-grow-0 mb-4 mb-gd-0 h-100 border-0">
                            <h1 className="sr-only visually-hidden">Navigation</h1>
                            <div className="block mt-3 text-center">
                                <div className={"d-flex mx-auto h-6 w-6 rounded-circle font-weight-bold mb-2 shadow" + (R.isNil(profilePicture) ? ' bg-gradient-stage': '')} role="button" data-toggle="modal" data-target="#changeavatar">
                                    {!R.isNil(profilePicture) ?
                                        <img className={"img-fluid h-100 w-100 rounded-inherit" + (widthIsBigger ? ' img-contain bg-white border': ' img-cover') } alt="avatar" src={profilePicture} /> :
                                        <i className="eva eva-image-2 h2 lh-1 m-auto icon-default"></i>
                                    }
                                </div>
                                <div className="h3 font-weight-bold lh-1 mb-0 px-1">{!R.isNil(user) ? `${user.firstName} ${user.lastName}` : ''}</div>
                                <ul className="nav navbar-inline align-items-center justify-content-around py-3 mt-lg-n1 container-paper mx-auto">
                                    <NavLink className={"nav-item inline-item o-80 o-100--hover"} activeClassName="o-100 active" to="/anticipa/settings">
                                        <div className="nav-link p-2 mb-0 lh-1">
                                            <i className="eva eva-settings-2-outline h3 lh-1 my-auto icon-default"></i>
                                        </div>
                                    </NavLink>
                                    {/* <Link className={"nav-item inline-item o-80 o-100--hover"} to="#">
                                        <div className="nav-link p-2 mb-0 lh-1">
                                            <i className="eva eva-bell-outline h3 lh-1 my-auto icon-default"></i>
                                        </div>
                                    </Link> */}
                                    <div role="button" className={"nav-item inline-item o-80 o-100--hover"} onClick={() => {
                                        localStorage.removeItem("access_token");
                                        setTimeout(() => {
                                            window.location = '/auth/signin';
                                        }, 100);
                                    }}>
                                        <div className="nav-link p-2 mb-0 lh-1">
                                            <i className="eva eva-power-outline h3 lh-1 my-auto icon-default"></i>
                                        </div>
                                    </div>
                                </ul>
                            </div>
                            <div className="nav-item show">
                                <div className="card rounded-0 bg-faded text-body shadow text-center">
                                    <div className="card-footer">
                                        <div className="h6 o-60 font-weight-bold lh-1 mb-1">Numéro de processus</div>
                                        <div className="h4 font-weight-bold lh-1 mb-0">{!R.isNil(user) && !R.isNil(user.processNumber) && user.processNumber ? user.processNumber :'N/D'}</div>
                                    </div>
                                </div>
                                <ul className="card-body navbar-nav">
                                    <NavLink className={"nav-item og-item"} exact to={"/anticipa" + (!R.isNil(user.setupCompletedDate) ? '/dashboard' : '')}>
                                        <div className="nav-link d-flex w-100 justify-content-between mb-0">
                                            <span className="font-weight-bolder text-uppercase">Tableau de bord</span>
                                            <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        </div>
                                    </NavLink>
                                    <NavLink className={"nav-item og-item"} exact to="/anticipa/referent">
                                        <div className="nav-link d-flex w-100 justify-content-between mb-0">
                                            <span className="font-weight-bolder text-uppercase">Mes mandataires</span>
                                            <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        </div>
                                    </NavLink>
                                    <NavLink className={"nav-item"} exact to="/anticipa/communes">
                                        <div className="nav-link d-flex w-100 justify-content-between mb-0">
                                            <span className="font-weight-bolder text-uppercase">Organismes de bases</span>
                                            <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                        </div>
                                    </NavLink>
                                    <NavLink className={"nav-item"} exact to="/anticipa/personal">
                                        <div className="nav-link d-flex w-100 justify-content-between mb-0">
                                            <span className="font-weight-bolder text-uppercase">Organismes complémentaires</span>
                                            <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                            <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                                <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink className={"nav-item"} exact to="/anticipa/biblioteque">
                                        <div className="nav-link d-flex w-100 justify-content-between mb-0">
                                            <span className="font-weight-bolder text-uppercase">bibliothèque de documents</span>
                                            <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                            <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                                <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <a className={"nav-item"} href="mailto:contact@assistarobase.fr">
                                        <div className="nav-link d-flex w-100 justify-content-between mb-0">
                                            <span className="font-weight-bolder text-uppercase">Nous contacter</span>
                                            <i className="eva eva-arrow-forward-outline mr-n3 h2 lh-1 my-auto"></i>
                                            <div className="done-check mr-n4 h3 p-2 px-3 my-auto">
                                                <i className="icn-done eva eva-checkmark-circle-outline"></i>
                                            </div>
                                        </div>
                                    </a>
                                </ul>
                            </div>
                        </nav>
                        
                        {
                            roles.indexOf("REPRESENTATIVE") > -1 ?
                                <button type="button" className="btn btn-light" onClick={(e) => {
                                    e.preventDefault();
                                    window.location="/facilita";
                                }}>Je suis mandataire(e)</button>
                            :
                            ''
                        }
                        
                    </div>
                </div>
            </header>
            <Avatar user={user} profilePicture={profilePicture} profilePictureDocument={profilePictureDocument}/>
        </React.Fragment>
    )
}